export default __webpack_public_path__ + "static/media/og-image.599580d5.png";